import { render, staticRenderFns } from "./kyc-video.vue?vue&type=template&id=5959a04a&scoped=true"
import script from "./kyc-video.vue?vue&type=script&lang=js"
export * from "./kyc-video.vue?vue&type=script&lang=js"
import style0 from "./kyc-video.vue?vue&type=style&index=0&id=5959a04a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5959a04a",
  null
  
)

export default component.exports